import { AsyncPipe, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NpHasAnyRoleDirective } from '@newpla/common';
import { Bs5PlaceholderFormComponent } from '@newpla/ng-lib';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
// sls-nova-shared 의 public-api 는 이 모듈을 import 하는 컴포넌트를 포함하므로(순환 참조), 디렉티브 파일을 직접 import 한다.
import { Bs5ModalHeaderDragDirective } from '../../../sls-nova-shared/src/components/bs5-modal-header-drag/bs5-modal-header-drag.directive';
import { NpSearchOverlayDirective } from '../../../sls-nova-shared/src/components/np-search-overlay/np-search-overlay.directive';
// 목록 로딩 모양: newpla 것 대신 새 디자인 컴포넌트를 쓴다. (selector 같음)
import { Bs5PlaceholderList2Component } from '../../../sls-nova-shared/src/components/bs5-placeholder-list2/bs5-placeholder-list2.component';

const modules = [
  CommonModule, RouterModule, NgbModule, AsyncPipe,
  Bs5PlaceholderFormComponent, Bs5PlaceholderList2Component,
  NpHasAnyRoleDirective, DragDropModule, NpHasAnyRoleDirective,
  // 모달 헤더를 잡고 이동
  Bs5ModalHeaderDragDirective,
  // 검색 조건 옵션 접기 (펼치면 그리드 위에 겹쳐 띄움)
  NpSearchOverlayDirective
];

@NgModule({
  declarations: [],
  imports: [modules],
  exports: [modules]
})
export class NpxCommonModule { }
